var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.mode === 'card')?_c('statement-komisi-card',{attrs:{"office-id":_vm.officeId}}):_c('statement-komisi-table',{attrs:{"office-id":_vm.officeId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }